import initialState from './initialState.js'

export const resetState = (state) => {
  const s = initialState()

  Object.keys(s).forEach(key => {
    state[key] = s[key]
  })
}

export const setRequests = (state, requests) => {
  state.requests = requests
}

export const addRequests = (state, request_acess) => {
  state.requests = state.requests.concat(request_acess)
}

export const removeRequest = (state, request_acess) => {
  const index = state.requests.findIndex(request => request.id === request_acess.id)

  state.requests.splice(index, 1)
}